import React from 'react'
import CareerComponent from '../section/career/Career'


const Career = () => {
  return (
    <div>
      <CareerComponent />
    </div>
  )
}

export default Career
